import { render, staticRenderFns } from "./orderiklan.vue?vue&type=template&id=266043f5"
import script from "./orderiklan.vue?vue&type=script&lang=js"
export * from "./orderiklan.vue?vue&type=script&lang=js"
import style0 from "./orderiklan.vue?vue&type=style&index=0&id=266043f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports